import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

import { OptionServiceDelivery } from '@app/forms/subscription/definition/interface/enum';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const optionLegalEntity: any[] =
      entity?.parameters?.optionLegalEntity || [];

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        optionLegalEntity: [entity?.parameters?.optionLegalEntity || []],
        //ADDITIONAL_PROPERTY
        additionalPropertyOption: [
          optionLegalEntity.includes(
            OptionServiceDelivery.ADDITIONAL_PROPERTY,
          ) || null,
        ],

        additionalProperty: [entity?.parameters?.additionalProperty || null],
        additionalPropertyNumber: [
          this.getAdditionamlPropertyNumber(
            entity?.parameters?.additionalPropertyNumber,
            optionLegalEntity,
          ),
        ],
        additionalPropertyTotal: [
          entity?.parameters?.additionalPropertyTotal || 60,
        ],
        // customizedOptimization: [entity?.customizedOptimization || null],
        // optimizedOptimization: [entity?.optimizedOptimization || 120],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as FormArray;
  }

  extract(): any[] {
    const formValue = _.cloneDeep(this.form?.value?.products);

    const extractedValues = formValue?.map(item => {
      const optionLegalEntity = this.extractOptionParticulier(item?.parameters);
      const updatedItem = this.removeUnusedFields(item?.parameters);

      return {
        ...item,
        parameters: {
          ...item.parameters,
          ...updatedItem,
          optionLegalEntity,
        },
      };
    });

    return extractedValues;
  }

  private extractOptionParticulier(item: any): string[] {
    const optionLegalEntity = [];

    if (
      item.additionalPropertyOption &&
      !optionLegalEntity.includes(OptionServiceDelivery.ADDITIONAL_PROPERTY)
    ) {
      optionLegalEntity.push(OptionServiceDelivery.ADDITIONAL_PROPERTY);
    }

    // if (
    //   item.optimizedSimulationOption &&
    //   !optionLegalEntity.includes(OptionServiceDelivery.OPTIMIZED_SIMULATION)
    // ) {
    //   optionLegalEntity.push(OptionServiceDelivery.OPTIMIZED_SIMULATION);
    // }

    // if (
    //   item.customizedSimulationOption &&
    //   !optionLegalEntity.includes(OptionServiceDelivery.CUSTOMIZED_SIMULATION)
    // ) {
    //   optionLegalEntity.push(OptionServiceDelivery.CUSTOMIZED_SIMULATION);
    // }

    return Array.from(new Set(optionLegalEntity));
  }

  private removeUnusedFields(item: any): any {
    const fieldsToRemove = [
      'additionalPropertyOption',
      // "optimizedSimulationOption",
      // "customizedSimulationOption",
      'tnsAffiliationOption',
    ];

    return _.omit(item, fieldsToRemove);
  }

  getAdditionamlPropertyNumber(item: any, optionLegalEntity: any) {
    if (item) {
      return item;
    }
    if (optionLegalEntity.includes(OptionServiceDelivery.ADDITIONAL_PROPERTY)) {
      return 1;
    }
    return 0;
  }
}
